import { PageHeader, Card, Badge, MarkdownView, EmptyState } from '../ui';
import { useBinder } from '../../lib/useBinder';
import { useFocusHighlight, focusId } from '../../lib/useFocusHighlight';
import { ShowButton } from '../common/ShowButton';
import shared from './sections.module.css';

/** NPC roster with public portraits and private DM notes. */
export function NpcsSection() {
  const ctx = useBinder();
  useFocusHighlight();
  if (!ctx) return null;
  const { adventure, instance, state, slug } = ctx;
  void state;

  return (
    <div>
      <PageHeader eyebrow="PNG" title="Personaggi non giocanti" />

      {!adventure.npcs.length ? (
        <EmptyState
          icon="🎭"
          title="Nessun PNG"
          description="Questa avventura non contiene personaggi non giocanti preparati."
        />
      ) : (
        <div className={shared.grid}>
          {adventure.npcs.map((npc) => (
            <Card key={npc.id ?? npc.name} id={focusId(npc.id)}>
              <div className={shared.entityHead}>
                <span className={shared.entityIcon} aria-hidden>
                  {npc.icon ?? '🎭'}
                </span>
                <h2 className={shared.entityName}>{npc.name}</h2>
                <div className={shared.cardActions}>
                  <ShowButton slug={slug} image={npc.image} title={npc.name} instanceId={instance.id} />
                </div>
              </div>

              <div className={shared.tagRow}>
                {npc.role && <Badge tone="gold">{npc.role}</Badge>}
                {npc.alive !== undefined && (
                  <Badge tone={npc.alive === false ? 'ember' : 'success'}>
                    {npc.alive === false ? 'Defunto' : 'Vivo'}
                  </Badge>
                )}
              </div>

              {npc.description && <MarkdownView>{npc.description}</MarkdownView>}

              {npc.notes && (
                <div className={shared.sectionBlock}>
                  <div className={shared.blockLabel}>Note DM</div>
                  <MarkdownView>{npc.notes}</MarkdownView>
                </div>
              )}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
